import React from 'react';

import CrashedComponent from '@app/components/errors/CrashedComponent';
import ReFilters from '@app/components/filters';
import ErrorBoundary from '@app/ErrorBoundary';

import { FILTER_ORIGIN } from '@app/constants/filters';

export const DefaultFiltersForm = () => {
    return (
        <ErrorBoundary FallbackComponent={CrashedComponent}>
            <ReFilters isDefaultOpen origin={FILTER_ORIGIN.SETTINGS} />
        </ErrorBoundary>
    );
};
